import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {CloButton, CloButtonLabel, CloSplitItems} from './button';
import {CloButtonsSplit} from './buttons-split';
import {CloIconButton} from './button-icon';
import {NgbDropdownModule} from '../dropdown/dropdown.module';


export {CloButton, CloButtonLabel, CloSplitItems} from './button';
export {CloButtonsSplit} from './buttons-split';
export {CloIconButton} from './button-icon';

@NgModule(
  {
    declarations: [CloButton,  CloButtonLabel, CloButtonsSplit, CloSplitItems, CloIconButton],
    exports: [CloButton, CloButtonLabel, CloButtonsSplit, CloSplitItems, CloIconButton],
    imports: [CommonModule, NgbDropdownModule],
    entryComponents: [CloButton, CloButtonsSplit, CloIconButton]
  })

export class CloButtonModule {
}
